// extracted by mini-css-extract-plugin
module.exports = {"form":"ShareSponsorshipEmail_form__nmQop","action":"ShareSponsorshipEmail_action__m3Jis"};